import Track from "webPage/Track";
export default function handleTestimonialsSliderBlocks() {
    let $reviewsSlider = $(".js-reviews-slider");
    if ($reviewsSlider.length > 0) {
        $reviewsSlider.each(function () {
            new Track($(this), {
                classes: {
                    block: "slider",
                },
            });
        });
    }
}
